export default "__VITE_ASSET__24d3754e__"